import { sidebarCollapseController } from "../_resources/ui-library.js";

import { holdButton } from "../_resources/ui-library.js";
import { supabaseClient as supabase } from "../auth/supabase.service.js";
import { getSupaServerList } from "../_resources/supa-helpers.js";
import { runWaffleSyncACL } from "../_resources/waffle-helpers.js"; 

function sameSecond(a, b) {
  return a != null && b != null && Math.floor(new Date(a) / 1000) === Math.floor(new Date(b) / 1000);
}

function expiresText(created_at, expires_at) {
  if (expires_at == null) return 'FOREVER';
  if (sameSecond(created_at, expires_at)) return 'no warranty';
  const expires = new Date(expires_at);
  const now = new Date();
  const diffMs = expires - now;
  if (Math.abs(diffMs) < 1000) return 'Expires now';
  const days = Math.ceil(Math.abs(diffMs) / (1000 * 60 * 60 * 24));
  if (diffMs > 0) return `Expires in: ${days} day${days !== 1 ? 's' : ''}`;
  return `Expired ${days} day${days !== 1 ? 's' : ''} ago`;
}

function isUnderAWeek(created_at, expires_at){
  if (expires_at == null) return false;
  if (sameSecond(created_at, expires_at)) return false;
  return (new Date(expires_at) - new Date()) < 1000 * 60 * 60 * 24 * 6;
}

const LinkModel = {
  async fetch(pageId) {
    const { data, error } = await supabase
      .from('links')
      .select('id, url, note, created_at, expires_at')
      .eq('page_id', pageId)
    return { data, error };
  },
  async extend(id) {
    const { error } = await supabase
      .from('links')
      .update({ expires_at: d3.utcWeek.offset(new Date(), 1) })
      .eq("id", id);
    return { error };
  },
  async delete(id) {
    const { error } = await supabase
      .from('links')
      .delete()
      .eq('id', id);
    return { error };
  },
  async updateServerACL() {
    //TODO: make it dependant on link instead of blank-syncinc all the servers
    return runWaffleSyncACL();
  }
};

export default function PermalinksView({dom, message, getToken}){
  const {bad, info, progress, good} = message;
  const panel = dom;
  let _pageId = null;
  sidebarCollapseController(dom.node());

  const LinkController = {
    async loadLinks(hasPageEditAccess) {
      const { data, error } = await LinkModel.fetch(_pageId);
      if (error) {
        panel.html('');
        return bad('Error loading links ' + JSON.stringify(error));
      }
      renderTable(data || [], hasPageEditAccess);
    },
    async extendLink(link, hasPageEditAccess) {
      const { error } = await LinkModel.extend(link.id);
      if (error) bad('Error extending link ' + JSON.stringify(error));
      good('Link extended', 3000);
      this.loadLinks(hasPageEditAccess);
    },
    async deleteLink(link, hasPageEditAccess) {
      const { error: e1 } = await LinkModel.delete(link.id);
      if (e1) bad('Error deleting link ' + JSON.stringify(e1));
      if (link.note) {
        const { error: e2 } = await LinkModel.updateServerACL();
        if (e2) bad('Error updating acl lists on servers after link deletion' + JSON.stringify(e2));
      }
      good('Link deleted', 3000);
      this.loadLinks(hasPageEditAccess);
    }
  };

  function render(pageId, hasPageEditAccess) {
    _pageId = pageId;
    LinkController.loadLinks(hasPageEditAccess);
  }


  function renderTable(links, hasPageEditAccess) {
    panel.html('');

    panel.append('div').class("admin-section-header").append('h1').text('Permalinks');

    const table = panel.append('table').attr('class', 'admin-table links-table');
    if (links.length > 0) table.append("tr")
      .call((rowEl) => {
        rowEl.append("th").text("url")
        rowEl.append("th").text("private datasets")
        rowEl.append("th").text("")
        rowEl.append("th").html("Maintenance wished")
        if (hasPageEditAccess) rowEl.append("th").text("")
      })

    table.selectAll('tr.link-row')
      .data(links.toSorted(((a,b) => a.id - b.id)))
      .enter()
      .append('tr')
      .attr('class', 'data-row link-row')
      .each(function(d) {
        const row = d3.select(this);
        row.append('td').html(d.url + (d.note ? '<span class=is-working>&t=.........SECRET..........</span>' : ''));        
        row.append('td').text(d.note || "");

        const openCell = row.append('td');
        openCell.append('a')
          .attr('href', d.open_url || d.url)
          .attr('target', '_blank')
          .text(d.note ? "Open without secret" : "Open");
        row.append('td').text(d => expiresText(d.created_at, d.expires_at));

        if (hasPageEditAccess) {
          const actionsCell = row.append('td').attr('class', 'actions-cell').append("div")
            .class("actionsbox micro");

          if(isUnderAWeek(d.created_at, d.expires_at)){
            const buttonExtend = actionsCell.append('span')
              .attr('class', 'button hold-btn')
              .text('Extend')
            holdButton(buttonExtend, async () => await LinkController.extendLink(d, hasPageEditAccess));
          }
                
          const buttonDelete = actionsCell.append('span')
            .attr('class', 'button delete hold-btn')
            .text('✘')
          holdButton(buttonDelete, async () => await LinkController.deleteLink(d, hasPageEditAccess));
        }

      });
  }

  return {render};
}








